if ($('[data-analytics-component]').length) {
  // Put analytics things in here
  import(/* webpackChunkName: "scroll-depth" */ './init-scroll-depth');
}
